module.exports = __webpack_public_path__ + "media/images/dashboard_icons/tax-43702cb6702a97afac5c88a42068a0b9.svg";